// extracted by mini-css-extract-plugin
export default {"sendingContainer":"EmailStatus_sendingContainer__j3cHJ"};